module.exports = __webpack_public_path__ + "img/no-one.819fd71e.svg";